import axios from 'axios';

// Get backend URL - same logic as main api.js
const getBackendURL = () => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const proto = window.location.protocol;
    
    if (host === 'localhost' || host === '127.0.0.1') {
      return 'http://localhost:8000';
    }
    
    if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(host)) {
      return proto + '//' + host + ':8000';
    }
    
    return proto + '//' + host;
  }
  return 'http://localhost:8000';
};

const apiClient = axios.create();

apiClient.interceptors.request.use((config) => {
  const backendURL = getBackendURL();
  config.baseURL = backendURL + '/api/admin';
  return config;
});

export const adminAPI = {
  // Create
  create: async (type, data) => {
    const response = await apiClient.post(`/${type}`, data);
    return response.data;
  },

  // Update
  update: async (type, id, data) => {
    const response = await apiClient.put(`/${type}/${id}`, data);
    return response.data;
  },

  // Delete
  delete: async (type, id) => {
    const response = await apiClient.delete(`/${type}/${id}`);
    return response.data;
  }
};
